import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

// Components
import {
  StateProvider,
  ShoppingProvider,
  ModalProvider,
} from "../StateProvider"
import Navigation from "../components/Navigation/Navigation"
import NavigationScroll from "../components/Navigation/NavigationScroll"
import Header from "../components/Header/Header"
import Veranstaltungen from "../components/Veranstaltungen/Veranstaltungen"
import Fahrgeschaefte from "../components/Fahrgeschaefte/Fahrgeschaefte"
import EisWagen from "../components/Eiswagen/Eiswagen"
import Footer from "../components/Footer/Footer"
import CookieModal from "../components/CookiesModal/CookiesModal"
import HasMounted from "../components/HasMounted"

const IndexPage = () => {
  return (
    <HasMounted>
      <ModalProvider>
        <ShoppingProvider>
          <StateProvider>
            <NavigationScroll site="index" />
            <Navigation site="index" />
            <Layout>
              <SEO title="Home" />
              <CookieModal />
              <Header />
              <Veranstaltungen />
              <Fahrgeschaefte site="home" />
              <EisWagen />
            </Layout>
            <Footer />
          </StateProvider>
        </ShoppingProvider>
      </ModalProvider>
    </HasMounted>
  )
}

export default IndexPage
